import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import PortalContainer from "../../components/Containers/PortalContainer";
import Button from "../../components/Button/Button";
import FilterButton from "../../components/Filter/FilterButton";
import { Div, Header } from "../../styles/Styles";
import ListScreen from "../../components/ListScreen/ListScreen";
import PlusIcon from "../../assets/Icons/PlusIccon.svg";
import Pagination from "../../components/Pagination/Pagination";
import Constants from "../../shared/Constants";
import Modal from "../../components/Modal/Modal";
import Card from "../../components/Card/Card";
import RoomService, { getRoomsList } from "../../services/RoomService";
import MainLoader from "../../components/Loader/MainLoader";
import Config from "../../config";
import { IsDesktop, IsMobile } from "../../components/ListScreen/Styles";
import { setLoader } from "../../store/actions/AppAction";
import SortButton from "../../components/Sorting/Sorting";
import { checkRightPermission } from "../../shared/utils";

const {
  language, sorting: { type: sortType, keys: { sortBy, sort } },
  filter: { components }, adminRoutes,
} = Constants;

class Rooms extends Component {
  roomsService = new RoomService(Config.apiBase);

  constructor(props) {
    super(props);
    const { userDetails = {}, location : { search } } = this.props;

    const userInfo = userDetails.user_access
      ? userDetails : localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {};

    const { permissions = [] } = userInfo;

    const hasWriteAccess= checkRightPermission(permissions,"is_room_editable",Constants.WRITE);

    const urlParams = new URLSearchParams(search);
    const pageNum = urlParams.get("page");

    this.state = {
      hasWriteAccess,
      deleteAccID: "",
      meta: {
        pageNumber: pageNum || 1,
        pageSize: 10,
        total: 0,
        pages: 0,
      },
      sortedBy: "",
      rooms: [],
      sortAscending: false,
      isFilterOpen: false,
      isDeleteModalOpen: false,
      isUserDeleted: false,
      filterOptions: [
        {
          id: "orders",
          component: components.CHECKBOX,
          label: language.common_orders,
          values: [{ label: language.filter_value_without_orders, value: "without_order" }],
          defaultValues: [],
          name: "orders",
        },
      ],
      toBeFilteredData: {},
      showSortModal: false,
      filterValues: [],
    };
  }

  async componentDidMount() {
    const { onLoading, history: { location }  } = this.props;
    onLoading(true);
    const { filterOptions } = this.state;
    const search = location.search;
    const params = new URLSearchParams(search);
    const applyFilters = JSON.parse(params.get("filter"));
    const { filter= {}, options = filterOptions } = applyFilters || {};
    this.setState({
      filterOptions: options,
      filterValues: applyFilters || {},
    });
    await this.fetchRooms(filter, false, options);
    onLoading(false);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      meta: { pageNumber },
      sortedBy,
      sortAscending,
      filterOptions,
      filterValues,
    } = this.state;
    const { location = {} } = this.props;
    const { filter= {}, options = filterOptions } = filterValues;
    if (
      prevState.meta.pageNumber !== pageNumber
      || location.key !== prevProps.location.key
      || sortedBy !== prevState.sortedBy
      || sortAscending !== prevState.sortAscending
    ) {
      this.fetchRooms(filter, false, options);
    }
  }

  /**
   *
   * @async
   * @function fetchRooms Fetches all types of rooms available.
   * @returns data of the rooms.
   *
   */
  fetchRooms = async (filters, searchInput, options = undefined) => {
    const {
      onLoading,
    } = this.props;
    onLoading(true);
    const {
      meta: { pageNumber, pageSize }, filterOptions,
      sortedBy, sortAscending, toBeFilteredData,
    } = this.state;
    const filterValues = options || filterOptions;
    const filter = filters || toBeFilteredData;
    const queryParams = [
      ["pageNumber", searchInput ? 1 : pageNumber],
      ["pageSize", pageSize],
      [sortBy, sortedBy],
      [sort, sortAscending ? sortType.ASC : sortType.DESC],
      ["filter", filter],
    ];
    try {
      const response = await getRoomsList(queryParams);
      const { meta = {}, data = [] } = response;
      const {
        current_page: currentPage, per_page: perPage, last_page: pages, total: totalCount,
      } = meta;
      const newMeta = {
        pageNumber: currentPage,
        pageSize: perPage,
        pages,
        totalCount,
      };
      window.scrollTo(0,0);
      this.setState({
        meta: newMeta,
        rooms: data,
        filterOptions: filterValues,
      });
      onLoading(false);
    } catch (e) {
      onLoading(false);
    }
  }

  /**
   *
   * @function handleAddRoom
   * Redirects to create new room page
   *
   */
  handleAddRoom = () => {
    const { history } = this.props;
    history.push(Constants.routes.addRoom.url);
  };

  /**
   *
   * Handles pagination
   * @param {Number} pageNumber page number
   *
   */
  handleGotoPage = (pageNumber) => {
    const { history } = this.props;
    this.setState(({ meta }) => ({
      meta: { ...meta, pageNumber },
    }));
    let currentUrlParams = new URLSearchParams(window.location.search);
    currentUrlParams.set("page", pageNumber);
    history.push(window.location.pathname + "?" + currentUrlParams.toString());
  };

  /**
   * Handles filter actions
   */
  handleCloseFilter = () => {
    const { isFilterOpen } = this.state;
    this.setState({ isFilterOpen: !isFilterOpen });
  };

  handleFilterApply=(filterValues = [], options = {}) => {
    const { history }=this.props;
    const filters = {};
    filterValues.map((obj) => {
      if (filters[obj.name]) {
        filters[obj.name].push(obj.value);
      } else {
        filters[obj.name] = [];
        filters[obj.name].push(obj.value);
      }
      return obj;
    });
    this.setState({
      toBeFilteredData: filters,
      isFilterOpen: false,
      filterValues: {
        filter: filters,
        values: filterValues,
        options,
      },
    });
    let currentUrlParams = new URLSearchParams(window.location.search);
    currentUrlParams.set("filter", JSON.stringify({ filter: filters, options }));
    currentUrlParams.set("page", 1);
    history.push(window.location.pathname + "?" + currentUrlParams.toString());
    this.fetchRooms(filters, filterValues, options);
  }

  /**
   *
   * Redirects to detailed view page
   * @param {object} item user data
   * @returns to selected user's detailed page
   *
   */
  handleDetailPage = (item) => {
    const { history } = this.props;
    history.push(`${adminRoutes.adminPrefix}/${adminRoutes.rooms}/${item.id}/${adminRoutes.editRoom}`);
  };

  handleEditRoom = (item) => () => {
    const { history } = this.props;
    history.push(`${adminRoutes.adminPrefix}/${adminRoutes.rooms}/${item.id}/${adminRoutes.editRoom}`);
  };

  /**
   * Opens a delete confirmation popup
   * @param {object} item selected room data
   */
  handleDeleteModal =(item) => {
    const { id = "" } = item;
    this.setState({ isDeleteModalOpen: true, deleteAccID: id }, () => {
      this.openElement.click();
    });
  };

  /**
   *
   * @async
   * @function handleDeleteRoom
   * Deletes the selected user.
   * @returns user deletion
   *
   */
   handleDeleteRoom =async () => {
     const { deleteAccID } = this.state;
     const { getFilters, onLoading } = this.props;
     onLoading(true);
     try {
       const response = await this.roomsService.deleteRoom(deleteAccID);
       if (response) {
         await getFilters();
         this.setState({ isDeleteModalOpen: false, isUserDeleted: true, deleteAccID: "" }, this.fetchRooms);
         onLoading(false);
       }
     } catch (e) {
       onLoading(false);
     }
   }

  /**
   * Cancels the user deletion operation
   */
  handleCancel = () => {
    this.setState({ isUserDeleted: false, isDeleteModalOpen: false });
  }

  /**
   *
   * Handles sorting of columns in the list screen
   * @param {object} item column data
   * @returns sorted list
   *
   */
  handleSorting=(item) => () => {
    const { sortedBy, sortAscending } = this.state;
    if (sortedBy === item) {
      this.setState({ sortAscending: !sortAscending }, this.fetchRooms);
    } else {
      this.setState({ sortedBy: item, sortAscending: true });
    }
  }

  handleRedirectToOrg=(id) => {
    const { history } = this.props;
    history.push(`${adminRoutes.adminPrefix}/${adminRoutes.organization}/${id}/${adminRoutes.editOrganization}`);
  };

  handleSortModal=() => {
    const { showSortModal } = this.state;
    this.setState({ showSortModal: !showSortModal });
  }

  handleApplySorting=(sortKey = "", sortOrder = false) => {
    this.setState({ sortedBy: sortKey, sortAscending: sortOrder, showSortModal: false });
  }

  render() {
    const {
      meta,
      filterOptions,
      isFilterOpen,
      isDeleteModalOpen,
      isUserDeleted,
      hasWriteAccess,
      rooms,
      sortedBy,
      sortAscending,
      showSortModal,
    } = this.state;
    const header = [
      {
        className: "col", value: language.filter_label_room, icon: sortType.ALPHABETS, key: "name",
      },
      {
        className: "col", value: language.list_header_organisations, icon: sortType.ALPHABETS, key: "organization_name",
      },
      {
        className: "col-2", value: language.common_services, icon: sortType.ARROW, key: "room_service_count",
      },
      {
        className: "col-2", value: language.list_header_open_assignments,
      },

    ];
    const value = [
      {
        className: "col",
        key: "name",
        type: "user",
        group: false,
        isDesktop: true,
      },
      {
        className: "col",
        key: "organization_id",
        type: "singleUser",
        group: false,
        isOrg: true,
      },
      {
        className: "col-2",
        key: "service_count",
        type: "number",
        group: false,
      },
      {
        className: "col-2",
        key: "open_assignments",
        type: "label",
        group: false,
      },
    ];
    const { isLoader } = this.props;
    return (
      <PortalContainer>
        <Div justifyContent="space-between" display="flex" pb={4}>
          <Div>
            <Header display="inline-block"><FormattedMessage id="common_rooms" /></Header>
          </Div>
          <IsDesktop>
            <Div className="row m-0">
              {hasWriteAccess && (
                <Button
                  label={<FormattedMessage id="room_add_new_room" />}
                  primary
                  startIcon={PlusIcon}
                  width="175px"
                  onClick={this.handleAddRoom}
                  padding="10px !important"
                />
              )}
              <FilterButton
                open={isFilterOpen}
                options={filterOptions}
                closeFilter={this.handleCloseFilter}
                onApply={this.handleFilterApply}
              />
            </Div>
          </IsDesktop>
        </Div>
        <IsMobile>
          <Div display="flex" justifyContent="space-between" pb={4}>
            {hasWriteAccess && (
              <Div>
                <Button
                  label={<FormattedMessage id="room_add_new_room" />}
                  primary
                  startIcon={PlusIcon}
                  width="175px"
                  onClick={this.handleAddRoom}
                  padding="10px !important"
                />
              </Div>
            )}
            <Div display="flex">
              <SortButton
                isOpen={showSortModal}
                sortingKeys={header}
                sortedBy={sortedBy}
                sortAscending={sortAscending}
                onClose={this.handleSortModal}
                onSubmit={this.handleApplySorting}
              />
              <FilterButton
                open={isFilterOpen}
                options={filterOptions}
                closeFilter={this.handleCloseFilter}
                onApply={this.handleFilterApply}
              />
            </Div>
          </Div>
        </IsMobile>
        {isLoader && <MainLoader type="list" />}
        {!isLoader && (
          <>
            <ListScreen
              moreButton
              deleteAction={hasWriteAccess}
              editAction={hasWriteAccess}
              header={header}
              value={value}
              data={rooms}
              onEdit={this.handleDetailPage}
              onDelete={this.handleDeleteModal}
              onClick={this.handleEditRoom}
              handleSorting={this.handleSorting}
              redirectToOrg={this.handleRedirectToOrg}
              sortedBy={sortedBy}
              sortAscending={sortAscending}
              dataNotFoundMessage={<FormattedMessage id="rooms_not_found" />}
            />
            {meta.pages > 1 && (
              <Div py={4} display={["block", "flex", "flex"]} >
                <Div display={["flex"]} justifyContent="center" alignItems="center">
                  {`${rooms.length < 10 ? rooms.length + ((meta.pageNumber - 1) * 10) : rooms.length * meta.pageNumber} / ${meta.totalCount}`}
                </Div>
                <Div width="90%" justifyContent="center">
                  <Pagination gotoPage={this.handleGotoPage} cursor={meta} />
                </Div>
              </Div>
            )}
          </>
        )}
        <a
          href
          data-toggle="modal"
          data-target="#Modal"
          data-backdrop="static"
          data-keyboard="false"
          ref={(openModal) => { this.openElement = openModal; }}
        />
        {isDeleteModalOpen && (
          <Modal>
            <Card
              header={<FormattedMessage id="room_delete_room" />}
              message={<FormattedMessage id="room_deleted_confirmation_message" />}
              buttonLabel={<FormattedMessage id="common_delete" />}
              confirmationCard
              buttonIcon={Constants.icons.DeleteIcon}
              onClick={this.handleDeleteRoom}
              onCancel={this.handleCancel}
              onLoader={isLoader}
            />
          </Modal>
        )}
        {isUserDeleted && (
          <Modal>
            <Card header={<FormattedMessage id="common_done" />} message={<FormattedMessage id="room_deleted_alert_message" />} alertCard buttonLabel={<FormattedMessage id="common_ok" />} onClick={this.handleCancel} />
          </Modal>
        )}
      </PortalContainer>
    );
  }
}
Rooms.propTypes = {
  history: PropTypes.node,
  location: PropTypes.node,
  onLoading: PropTypes.func,
  isLoader: PropTypes.bool,
  userDetails: PropTypes.node,
  roomFilters: PropTypes.node,
  organizationFilters: PropTypes.node,
  getFilters: PropTypes.func,
};
Rooms.defaultProps = {
  history: null,
  location: null,
  onLoading: () => {},
  isLoader: false,
  userDetails: {},
  roomFilters: [],
  organizationFilters: [],
  getFilters: () => {},
};

function mapDispatchToProps(dispatch) {
  return {
    onLoading: (payload) => dispatch(setLoader(payload)),
  };
}
const mapStateToProps = (state) => ({
  isLoader: state.AppReducer.isLoader,
  userDetails: state.AppReducer.userDetails,
  roomFilters: state.FilterReducer.roomFilters,
  organizationFilters: state.FilterReducer.organizationFilters,
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
)(Rooms);
